import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    myDelegations: 'My Delegations',
    withdrawals: 'Withdrawals',
  },
};
